<template>
  <div class="hidden"></div>
</template>

<script>
import Events from './events'

export default {
  components: {},
  props: {
    events: {
      type: [String, Array],
      default: '',
    },
    uniqId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      eventsIds: [],
    }
  },
  mounted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    this.listenEvents()
  },
  beforeUnmount() {
    this.unsubscribeListeners()
  },
  methods: {
    unsubscribeListeners() {
      this.eventsIds.forEach(Events.removeHandler)
    },
    listenEvents() {
      if (Array.isArray(this.events)) this.events.forEach(this.listenEvent)
      else this.listenEvent(this.events)
    },
    listenEvent(eventName) {
      const id = Events.handle(
        eventName,
        (...args) => {
          this.onEvent(eventName, ...args)
        },
        this.uniqId,
      )
      this.eventsIds.push(id)
    },
    onEvent(eventName, ...data) {
      this.$emit(eventName, ...data)
      this.$emit('eventReceived', { name: eventName, data })
    },
  },
}
</script>
